module.exports = __webpack_public_path__ + "img/teamwork-power-successful-business-meeting-workplace-concept.c8c7da42.jpg";